import { useContext, useState, useEffect } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import GlobalContext from '../../../contexts/index';
import useFetchData from '../../../hooks/useFetchData';
import useSort from '../../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import globalTranslating from '../../../translate.json';
import reportTranslating from '../translate.json';
import SnackBar from 'components/SnackBar';

const ReportPage = () => {
  const translating = { ...globalTranslating, ...reportTranslating };
  const { data: subCategoriesData } = useFetchData('report-text/SubCategoris');

  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const [filteredBloodParams, setReportRows] = useState([]);
  const { data: reportData, loading } = useFetchData('report-text');
  const [searchParams] = useSearchParams();
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    const isAdded = searchParams.get('added');
    if (isAdded) {
      setShowSnakbar(true);
      searchParams.delete('added');
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}${window.location.pathname}`
      );
    }
  }, []);

  function mapTableData(data) {
    const mappedReportData = data.map((row) => ({
      ...row,
      geneSubCategoryName: row?.name
    }));
    return mappedReportData;
  }

  useEffect(() => {
    if (reportData?.length) {
      setReportRows(mapTableData(reportData));
    }
  }, [reportData]);

  const onFilter = (filteredData) => {
    setReportRows(mapTableData(filteredData));
  };

  const onResetFilters = () => {
    setReportRows(mapTableData(reportData));
  };

  const { showFilters, toggle } = useSort();

  const tableHeaders = [
    translating.reportTextNo,
    translating.reportTextType,
    translating.geneSubCategoryName,
    translating.lastUpdate
  ];

  const columns = [
    //change to what comes from API
    { value: 'reportTextNo' },
    { value: 'reportTextType' },
    { value: 'geneSubCategoryName' },
    { value: 'lastUpdated', format: 'date' }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['reportTextNo', 'reportTextType', 'geneSubCategoryName', 'name']
    },
    {
      type: 'autocomplete',
      label: translating.type,
      name: 'reportTextType',
      options: [
        { id: 'Static', name: 'Static' },
        { id: 'Dynamic', name: 'Dynamic' },
        { id: 'MCategory', name: 'MCategory' },
        { id: 'KSubCategory', name: 'KSubCategory' },
        { id: 'ShortSubCategory', name: 'ShortSubCategory' },
        { id: 'Category', name: 'Category' },
        { id: 'subCategory', name: 'subCategory' },
        { id: 'MRCategory', name: 'MRCategory' }
      ],
      searchBy: 'name'
    },
    {
      type: 'autocomplete',
      label: translating.geneSubCategoryName,
      name: 'gscId',
      options: subCategoriesData,
      searchBy: 'name'
    }
  ];

  const actionsUsersList = [
    {
      icon: SortIcon,
      bottom: true,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setReportRows(reportData);
        toggle(!showFilters);
      }
    }
  ];

  return (
    <div className="blood-params-list">
      <ListHeader
        title={translating.reportTitle}
        newItem={{ handleClick: () => setLink('d2') }}
        actions={actionsUsersList}
      ></ListHeader>
      {showFilters && subCategoriesData?.length && (
        <Filter
          fields={sortFields}
          data={reportData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="blood-params-wrapper-table">
        {loading && <div>Loading</div>}
        {reportData && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredBloodParams}
            pagination={true}
            handleRowClick={(id) => {
              navigate(`/labs/report/${id}`);
            }}
          ></TablePagination>
        )}
      </div>
      {showSnackbar && (
        <SnackBar
          msg={'שדה נוסף'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default ReportPage;
